export default {
  title: '欢迎使用控制塔系统',
  subtitle: '您的智能物流管理平台，让货运更简单高效',
  quickAccess: '快捷入口',
  enterSystem: '进入系统',
  settings: '设置',
  settingsTitle: '快捷入口设置',
  approval: {
    title: '审批事项',
    refresh: '刷新',
    moreFilter: '更多筛选',
    search: '查询',
    reset: '重置',
    searchPlaceholder: '流程名称 / 审批流水号',
    empty: '暂无审批事项',
    currentScope: '当前：{scope}',
    tree: {
      initiated: '我发起的审批',
      processing: '我处理的审批'
    },
    categories: {
      billPayment: '付款申请单',
      makeInvoice: '开票申请单',
      jobCharge: '业务费用申请单',
      tempCredit: '临时信控申请单',
      chargeChange: '费用更改申请单',
      collectInvoice: '收票申请单',
      partnerApplication: '合作伙伴申请单',
      contractApplication: '合同申请单',
      advancePaymentRefund: '预付款退款申请单',
      customFormPrefix: '{name}',
      platformCategories: {
        inquiryFcl: '韶音整箱询价比价确认',
        inquiryLcl: '韶音拼箱询价比价确认',
        inquiryAir: '韶音空运询价比价确认',
        inquiryPrePort: '韶音港前询价比价确认',
        inquiryLastMile: '韶音末端询价比价确认',
        tcFee: '供应商对账',
        settlementBillApproval: '账单审批申请',
        specialPriceApplication: '特价申请',
        transportConsignmentFeeChange: '费用更改申请'
      }
    },
    states: {
      all: '全部',
      processing: '处理中',
      completed: '已完成',
      ordered: '已下单',
      cancelled: '已取消',
      abandoned: '已废弃'
    },
    columns: {
      index: '序号',
      documentProcessNo: '审批流水号',
      applicationDimension: '申请维度',
      applicationCode: '业务单号',
      feeChangeApplicationCode: '申请编码',
      documentConfigName: '表单类型',
      docNo: '业务单号',
      createDate: '发起时间',
      workflowName: '流程名称',
      currentApprover: '当前审批人',
      state: '状态',
      officeName: '发起分公司',
      initiateBranchCompany: '发起分公司',
      creator: '发起人',
      lastModified: '更新时间',
      consignor: '委托主体公司',
      supplierName: '供应商名称',
      businessCreatedAt: '业务创建时间',
      etd: 'ETD',
      eta: 'ETA',
      atd: 'ATD',
      ata: 'ATA',
      action: '操作'
    },
    applicationDimensions: {
      inquiry: '询价单',
      bill: '账单',
      transportConsignment: '运输委托单'
    },
    actions: {
      process: '处理',
      orderNow: '立即下单',
      approve: '同意',
      reject: '拒绝',
      undo: '撤回',
      rollback: '撤销',
      return: '退回',
      cancel: '取消',
      addSignature: '加签',
      transferSignature: '转签',
      viewHistory: '查看流程记录'
    },
    detail: {
      title: '审批处理',
      basicInfo: '基础信息',
      businessInfo: '业务详情',
      businessEmpty: '暂无业务字段',
      remarkTitle: '审批意见',
      remarkPlaceholder: '填写审批备注',
      attachmentTitle: '审批附件',
      uploadAttachment: '上传附件',
      uploadingAttachment: '附件仍在上传，请稍候',
      attachmentSizeLimit: '单个附件不能超过 20MB',
      attachmentSizeLimitWithMb: '单个附件不能超过 {size}MB',
      attachmentTypeLimit: '仅支持 PDF、JPG、PNG 格式附件',
      fileMissing: '文件信息缺失',
      uploadFailed: '附件上传失败',
      downloadFailed: '附件下载失败',
      unknownFile: '未知文件',
      addSignaturePlaceholder: '请选择加签用户，可搜索姓名、账号或手机号',
      transferSignaturePlaceholder: '请选择转签用户，可搜索姓名、账号或手机号',
      availableActions: '可执行动作',
      noAvailableActions: '当前没有可处理动作',
      workflowRecords: '流程记录',
      noWorkflowRecords: '暂无流程记录',
      nodeFallback: '节点 {node}',
      operatorLabel: '处理人：',
      remarkLabel: '备注：',
      noRemark: '无',
      fixedApprover: '固定处理人：{users}',
      disableAddSignature: '不可加签：{users}',
      hintSeparator: '；',
      selectAddSignatureUser: '请先选择加签用户',
      selectTransferSignatureUser: '请先选择转签用户',
      disabledAddSignatureUsers: '以下用户不可加签：{users}',
      confirmTitle: '审批确认',
      confirmContent: '确定执行【{action}】吗？',
      success: '审批处理成功'
    },
    panel: {
      flowInfo: '流程信息',
      flowNo: '流程编号',
      flowName: '流程名称',
      initiator: '发起人',
      applyTime: '发起时间',
      currentApprover: '当前审批人',
      relatedDoc: '关联单据',
      progress: '审批进度',
      progressPending: '审批待处理',
      attachments: '审批附件',
      noAttachments: '暂无附件',
      download: '下载',
      remark: '审批意见',
      remarkPlaceholder: '请输入审批意见（可选）',
      noActions: '当前无可执行操作',
      approve: '同意',
      reject: '驳回',
      return: '退回',
      rollback: '回退',
      cancel: '作废',
      undo: '撤回',
      confirmTitle: '确认审批',
      confirmContent: '确定执行「{action}」操作吗？',
      actionSuccess: '审批操作成功',
      actionFailed: '审批操作失败',
      loadFailed: '加载审批信息失败',
      defaultFlowName: '审批流程'
    },
    filters: {
      title: '审批事项筛选',
      workflowName: '流程名称',
      documentProcessNo: '审批流水号',
      docNo: '业务单号',
      approveByName: '审批人',
      officeName: '发起公司',
      state: '状态'
    },
    batch: {
      approve: '同意',
      reject: '拒绝',
      emptySelection: '请选择审批事项',
      confirmTitle: '批量审批确认',
      confirmContent: '确定要{action}选中的 {count} 条审批事项吗？',
      success: '{action}成功',
      partialFailed: '部分审批处理失败'
    },
    history: {
      title: '流程记录',
      basicInfo: '基础信息',
      timeline: '审批记录',
      empty: '暂无流程记录',
      node: '节点',
      currentNode: '当前节点',
      approver: '审批人',
      remark: '备注',
      noRemark: '无',
      missingProcessId: '缺少流程实例ID，无法查看流程记录'
    }
  },
  shortcuts: {
    rateQuery: '运价查询',
    inquiryManagement: '询价管理',
    quotationManagement: '报价管理',
    rateMaintenance: '运价维护',
    orderManagement: '订单管理',
    scheduleQuery: '船期查询',
    controlTower: '控制塔面板',
    customerCenter: '客商中心',
    userCenter: '用户中心',
    apiCenter: 'API中心',
    applicationCenter: '应用中心',
    systemSettings: '系统设置'
  }
}
